import { LockFilled } from '@ant-design/icons'
import './Forbidden.style.less'

function Forbidden() {
  return (
    <div className="forbidden-container">
      <LockFilled />
      <p className="title">Unauthorized Access</p>
      <p className="desc">You do not have permission to access this record.</p>
    </div>
  )
}

export default Forbidden
